import { render, staticRenderFns } from "./ServiceReports.vue?vue&type=template&id=24f76e6c&"
import script from "./ServiceReports.vue?vue&type=script&lang=js&"
export * from "./ServiceReports.vue?vue&type=script&lang=js&"
import style0 from "./ServiceReports.vue?vue&type=style&index=0&id=24f76e6c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports